import React from 'react';
import { UI_CONSTANTS } from '../../constants/ui';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  layout?: 'center' | 'top-toast';
}

const getSizeClasses = (size: 'sm' | 'md' | 'lg'): string => {
  switch (size) {
    case 'sm':
      return 'h-3.5 w-3.5';
    case 'lg':
      return 'h-12 w-12';
    case 'md':
    default:
      return 'h-8 w-8';
  }
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = 'Loading...', 
  size = 'md',
  className = '',
  layout = 'center'
}) => {
  if (layout === 'top-toast') {
    return (
      <div className={`fixed top-3 left-1/2 z-50 w-[min(92vw,48rem)] -translate-x-1/2 ${className}`}>
        <div className="rounded-lg border border-slate-200 bg-white/95 px-3 py-2.5 shadow-xl backdrop-blur dark:border-slate-700 dark:bg-slate-900/95 sm:px-4">
          <div className="flex items-center gap-3">
            <div className={`${UI_CONSTANTS.ANIMATIONS.spin} ${getSizeClasses(size)} border-b-2 border-emerald-600 dark:border-emerald-400`}></div>
            <p className="truncate text-sm font-medium text-slate-800 dark:text-slate-200">{message}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center p-8 ${className}`}>
      <div className="text-center">
        <div className={`${UI_CONSTANTS.ANIMATIONS.spin} ${getSizeClasses(size)} border-b-2 border-emerald-600 dark:border-emerald-400 mx-auto mb-4`}></div>
        <p className="text-slate-600 dark:text-slate-300">{message}</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
